<template>
  <div class="contact-us" ref="contactUs">
    <div class="bj"></div>
    <div class="consult">
      <div class="text">
        <div class="t1">产品咨询</div>
        <div class="t2">您可以通过一下方式联系我们</div>
      </div>
      <div class="consult-type-liet">
        <div class="consult-type-box">
          <div class="title">售前咨询</div>
          <div class="txt">
            专属客户经理在线解答，提供1v1购买咨询，解决方案，产品介绍等服务
          </div>
          <div class="work">
            <img src="@/assets/lxfsh5.png" class="img" alt="" />
            <div class="tx">周一至周六 9:00 — 20:00</div>
          </div>
          <div class="phone">咨询热线：400-086-1123</div>
        </div>
      </div>
      <div class="consult-type-liet">
        <div class="consult-type-box">
          <div class="title">邮件咨询</div>
          <div class="txt">产品使用问题及技术支持</div>
          <div class="work">
            <img src="@/assets/Icon_mail.png" class="img" alt="" />
            <div class="tx">发送至 1290942119@qq.com</div>
          </div>
        </div>
      </div>
      <div class="consult-type-liet">
        <div class="consult-type-box">
          <div class="title">企业微信售前咨询</div>
          <div class="txt">付费咨询、解决方案，需求定制等技术咨询</div>
          <div class="qywx">
            <div class="wx-txt">请扫描右方二维码 添加企业微信好友</div>
            <div class="img-box">
              <img src="@/assets/qywx.png" class="img" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  activated() {
    this.$refs.contactUs.scrollIntoView();
  },
};
</script>

<style lang="less" scoped>
.contact-us {
  .bj {
    width: 750px;
    height: 640px;
    background: url("~@/assets/contactUs.png") no-repeat;
    background-size: 100% 100%;
  }
  .consult {
    padding: 40px;
    .text {
      text-align: center;
      .t1 {
        font-size: 40px;
        line-height: 48px;
        color: #292929;
        font-weight: 500;
      }
      .t2 {
        font-size: 28px;
        line-height: 40px;
        color: #626e81;
      }
    }
    .consult-type-liet {
      padding: 32px;
      background: linear-gradient(180deg, #f3f5f8 0%, #ffffff 100%);
      border: 4px solid #ffffff;
      box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
      border-radius: 8px;
      margin-top: 24px;
      .title {
        font-size: 40px;
        line-height: 56px;
        font-weight: 500;
        color: #336fff;
      }
      .txt {
        margin-top: 20px;
        font-size: 28px;
        line-height: 40px;
        color: #3d485d;
      }
      .qywx {
        margin-top: 32px;
        display: flex;
        align-items: center;
        .wx-txt {
          background: #ffffff;
          box-shadow: 4px 4px 20px rgba(55, 99, 170, 0.16);
          border-radius: 8px;
          width: 288px;
          height: 128px;
          padding: 24px 32px;
          font-size: 28px;
          line-height: 40px;
          color: #3d485d;
        }
        .img-box {
          margin-left: 64px;
          width: 180px;
          height: 180px;
          .img {
            width: 180px;
            height: 180px;
          }
        }
      }
      .work {
        display: flex;
        align-items: center;
        margin-top: 32px;
        .img {
          width: 64px;
          height: 64px;
        }
        .tx {
          margin-left: 24px;
          font-size: 28px;
          line-height: 40px;
          color: #3d485d;
        }
      }
      .phone {
        margin-top: 32px;
        font-size: 32px;
        font-weight: 500;
        color: #336fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/h5/contactUsH5.vue